import { render, staticRenderFns } from "./SelectNestedEntities.vue?vue&type=template&id=023b8738"
import script from "./SelectNestedEntities.vue?vue&type=script&lang=js"
export * from "./SelectNestedEntities.vue?vue&type=script&lang=js"
import style0 from "./SelectNestedEntities.vue?vue&type=style&index=0&id=023b8738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports